/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferDetailedResponse } from '../../models/offer-detailed-response';
import { OfferModificationRequest } from '../../models/offer-modification-request';

export interface UpdateOffer$Params {
  offerRequestId: string;
  offerId: string;
      body: OfferModificationRequest
}

export function updateOffer(http: HttpClient, rootUrl: string, params: UpdateOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferDetailedResponse>> {
  const rb = new RequestBuilder(rootUrl, updateOffer.PATH, 'put');
  if (params) {
    rb.path('offerRequestId', params.offerRequestId, {});
    rb.path('offerId', params.offerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferDetailedResponse>;
    })
  );
}

updateOffer.PATH = '/offers/requests/{offerRequestId}/offers/{offerId}';
